import pluralize from 'pluralize';

import {
  handleErrors as handleErrorsHelper,
  parseAsJson as parseAsJsonHelper,
  replaceParams,
} from '../../utils/requestHelpers';
import fetchService from '../../utils/fetchService';

const getApi = ({
  pageTitle,
  endpoints = {},
  options: {
    fetch = fetchService,
    handleErrors = handleErrorsHelper,
    parseAsJson = parseAsJsonHelper,
    parseResponseErrorWithDetails = false,
  } = {},
}) => {
  const getMethod = (endpoint, method) => endpoint ? method : undefined; // eslint-disable-line no-undefined

  const fetchEntities = getMethod(endpoints.FETCH, async params => await fetch(
    replaceParams(endpoints.FETCH, params)
  )
    .then(handleErrors({ errorMessage: `Fetching ${pluralize.plural(pageTitle)} failed` }))
    .then(parseAsJson));

  const addEntity = getMethod(endpoints.INSERT, async (entity, params) => await fetch(
    replaceParams(endpoints.INSERT, params),
    {
      method: 'POST',
      body: JSON.stringify(entity),
    }
  )
    .then(handleErrors({
      errorMessage: `Inserting ${pageTitle} failed`,
      parseResponseErrorWithDetails,
    })));

  const updateEntity = getMethod(endpoints.UPDATE, async (entity, params) => await fetch(
    replaceParams(endpoints.UPDATE, params),
    {
      method: 'PUT',
      body: JSON.stringify(entity),
    }
  )
    .then(handleErrors({ errorMessage: `Updating ${pageTitle} failed` })));

  const removeEntity = getMethod(endpoints.DELETE, async params => await fetch(
    replaceParams(endpoints.DELETE, params),
    {
      method: 'DELETE',
    }
  )
    .then(handleErrors({ errorMessage: `Removing ${pageTitle} failed` })));

  const validateEntities = getMethod(endpoints.VALIDATE, async (entities, params) => await fetch(
    replaceParams(endpoints.VALIDATE, params),
    {
      method: 'POST',
      body: JSON.stringify(entities),
    }
  )
    .then(handleErrors({ errorMessage: `Validating ${pluralize.plural(pageTitle)} failed` }))
    .then(parseAsJson));

  const importEntities = getMethod(endpoints.IMPORT, async (entities, params) => await fetch(
    replaceParams(endpoints.IMPORT, params),
    {
      method: 'POST',
      body: JSON.stringify(entities),
    }
  )
    .then(handleErrors({ errorMessage: `Importing ${pluralize.plural(pageTitle)} failed` })));

  return {
    fetchEntities,
    addEntity,
    updateEntity,
    removeEntity,
    validateEntities,
    importEntities,
  };
};

export default getApi;
